export default function PHP_simplexml_import_dom() {
  return (
    <div>
      <h1>PHP_simplexml_import_dom</h1>
    </div>
  );
}
